import {Injectable, signal} from '@angular/core';
import {RecordsDataRequestQueryParams} from "../../../../types/records-table.types";
import {defaultRecordsDataRequestQueryParams} from "../../../../models/default-records-data-request-query-params";

@Injectable({
  providedIn: 'root'
})
export class ProductCardsRequestQueryParamsStateService {
  private _productCardsRequestQueryParams = signal<RecordsDataRequestQueryParams>(defaultRecordsDataRequestQueryParams);
  public productCardsRequestQueryParams = this._productCardsRequestQueryParams.asReadonly();

  public updateProductCardsRequestQueryParams(searchValue?: string): void {
    this._productCardsRequestQueryParams.update((current) => {
      return {
        ...current,
        size: undefined,
        search: searchValue
      };
    });
  }
}
